import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DemoProvider } from "../demo/demo";
import * as moment from "moment";
import { TimeParams } from "../../models/TimeParams";

export const DEFAULT_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

@Injectable()
export class TimeProvider {
  // Default date used in the local offline files
  demoDate = "2018-11-14";

  public timeParse = [
    {
      displayText: "1W",
      days: 7,
      momentType: "weeks",
      momentValue: 1,
    },
    {
      displayText: "1M",
      days: 30,
      momentType: "months",
      momentValue: 1,
    },
    {
      displayText: "3M",
      days: 90,
      momentType: "months",
      momentValue: 3,
    },
    {
      displayText: "1Y",
      days: 365,
      momentType: "years",
      momentValue: 1,
    },
  ];

  constructor(public http: HttpClient, private demo: DemoProvider) {}

  getDefaultFormat() {
    return DEFAULT_TIME_FORMAT;
  }

  getTimeParams(timeRange: number): TimeParams {
    if (this.demo.demoMode) {
      return this.getDemoModeParams(timeRange);
    } else {
      let index = this.timeParse.findIndex((t) => t.days == timeRange);
      let selectedTime = this.timeParse[index];
      if (index > -1) {
        return {
          from: moment()
            .add(
              -selectedTime.momentValue,
              selectedTime.momentType as moment.DurationInputArg2
            )
            .format(DEFAULT_TIME_FORMAT),
          to: moment().format(DEFAULT_TIME_FORMAT),
          prevFrom: moment()
            .add(
              -2 * selectedTime.momentValue,
              selectedTime.momentType as moment.DurationInputArg2
            )
            .format(DEFAULT_TIME_FORMAT),
          prevTo: moment()
            .add(
              -selectedTime.momentValue,
              selectedTime.momentType as moment.DurationInputArg2
            )
            .format(DEFAULT_TIME_FORMAT),
          range: timeRange,
        };
      } else {
        return {
          from: moment().add(-timeRange, "d").format(DEFAULT_TIME_FORMAT),
          to: moment().format(DEFAULT_TIME_FORMAT),
          prevFrom: moment()
            .add(-2 * timeRange, "d")
            .format(DEFAULT_TIME_FORMAT),
          prevTo: moment().add(-timeRange, "d").format(DEFAULT_TIME_FORMAT),
          range: timeRange,
        };
      }
    }
  }

  getTimeParamsDataRefresh(timeRange: number): TimeParams {
    if (this.demo.demoMode) {
      return this.getDemoModeParams(timeRange);
    } else {
      return {
        from: moment()
          .add(-timeRange, "d")
          .set({ hour: 0, minute: 0, second: 0 })
          .format("YYYY-MM-DDTHH:mm:ss"),
        to: moment().format("YYYY-MM-DDTHH:mm:ss"),
        prevFrom: moment()
          .add(-2 * timeRange, "d")
          .set({ hour: 0, minute: 0, second: 0 })
          .format("YYYY-MM-DDTHH:mm:ss"),
        prevTo: moment().add(-timeRange, "d").format("YYYY-MM-DDTHH:mm:ss"),
        range: timeRange,
      };
    }
  }

  getTimeParamsForCustomRange(from: string, to: string, type?: string): any {
    console.log(moment(to).format(DEFAULT_TIME_FORMAT));
    let now = moment();
    let preciseTo = moment(to)
      .minutes(now.minutes())
      .seconds(now.seconds())
      .hours(now.hours());
    let preciseFrom = moment(from)
      .minutes(now.minutes())
      .seconds(now.seconds())
      .hours(now.hours());
    let timeDif = preciseTo.diff(preciseFrom, "days");
    if (this.demo.demoMode) {
      return this.getDemoModeParams(timeDif);
    } else {
      let timeRange = {
        from: preciseFrom.format(DEFAULT_TIME_FORMAT),
        to: preciseTo.format(DEFAULT_TIME_FORMAT),
        prevFrom: preciseFrom.add(-timeDif, "d").format(DEFAULT_TIME_FORMAT),
        prevTo: preciseTo.add(-timeDif, "d").format(DEFAULT_TIME_FORMAT),
        range: timeDif,
      };
      return timeRange;
    }
  }

  getDemoModeParams(timeRange: number): any {
    return {
      from: moment(this.demoDate).add(-timeRange, "d").format("YYYY-MM-DD"),
      to: moment(this.demoDate).format("YYYY-MM-DD"),
      prevFrom: moment(this.demoDate)
        .add(-2 * timeRange, "d")
        .format("YYYY-MM-DD"),
      prevTo: moment(this.demoDate).add(-timeRange, "d").format("YYYY-MM-DD"),
      range: timeRange,
    };
  }

  demoDateDisplay(date: any): any {
    const diff = moment().diff(this.demoDate, "days");
    if (this.demo.demoMode) {
      return moment(date).add(diff, "days").toString();
    } else {
      return date;
    }
  }

  get(): string {
    return moment().format(DEFAULT_TIME_FORMAT);
  }

  add(current: string, ammount: number, type: "d"): string {
    return moment(current).add(ammount, type).format(DEFAULT_TIME_FORMAT);
  }
}



// WEBPACK FOOTER //
// ./src/providers/time/time.ts